import _ from 'lodash'
import { formDecorator } from '../../../Common/forms'
import { UPDATE_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import validationList from '../ProposalForm/Shared/validation/validationList'
import { validateFlow } from '../ProposalForm/Shared/validation/validations'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

const DEFAULT_VALIDATION_LIST = {
  applicant: validationList.applicant
}

export const getValidationList = values => {
  const proposalType = _.get(values, 'type')
  switch (proposalType) {
    case PROPOSAL_TYPE.UPDATE_COPY: {
      const isBatchUpdateCopy = !_.isEmpty(
        _.get(values, 'listings', [])
      )
      return ({
        ...DEFAULT_VALIDATION_LIST,
        // 非"批次"修改詳情與保證時才驗證單一欄位 copy
        ...(!isBatchUpdateCopy && {
          'listing.copy': validationList['product.copy']
        })
      })
    }
    default: {
      return DEFAULT_VALIDATION_LIST
    }
  }
}

const syncValidator = (values) => {
  const validationList = getValidationList(values)

  const errors = {}

  _.map(validationList, (validations, fieldName) => {
    const fieldValue = _.get(values, fieldName, '')
    _.set(
      errors,
      fieldName,
      validateFlow(...validations)(fieldValue, values)
    )
  })

  return errors
}

export const UPDATE_LISTING_FORM_CONFIG = {
  form: UPDATE_LISTING_FORM_KEY,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // unregister fields on unmount
  validate: syncValidator,
  asyncBlurFields: []
}

function withUpdateListingForm (MainComponent, customFormConfig = {}) {
  return formDecorator(_.merge(UPDATE_LISTING_FORM_CONFIG, customFormConfig))(MainComponent)
}

export default withUpdateListingForm
